const notifications = {
	title: "Notifications",
	new_notification: "New Notification",
	edit_notification: "Edit Notification: {name}",
	view_notification: "View Notification: {name}",
	list_title: "List of Notifications",
	create_title: "Create Notification",
	update_title: "Update Notification",
	site: "Site",
	header: "Header",
	body: "Body",
	start_date: "Start date",
	start_time: "Start time",
	end_date: "End date",
	end_time: "End time",
	trigger: "Trigger",
	type: "Type",
	status: "Status",
};
export default notifications;